export default __webpack_public_path__ + "static/media/trib_w_bg.6c1bdca6.png";